<template>
  <div>
    <center>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>

          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <v-icon
                color="#871B12"
                size="30"
                @click="shift_import()"
                >mdi-calendar-search</v-icon
              >
            </v-sheet>
          </v-col>
        </v-card>
            <p></p>
            <v-card>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr style="background-color: #1b437c">
                      <th class="text-center">วัน</th>
                      <th class="text-center">เวลา</th>
                      <th class="text-center">สี</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(items, index) in shifttem" :key="index">
                      <td class="text-center">
                        {{ items.shiftDay }}
                      </td>
                      <td v-if="items.time_as" class="text-center">
                        {{ items.time_as }}
                      </td>
                      <td v-if="!items.time_as" class="text-center">-</td>
                      <td v-if="items.color" class="text-center">
                        <v-chip
                          v-if="items.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ items.color }}
                        </v-chip>
                        <v-chip
                          v-if="items.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ items.color }}
                        </v-chip>
                        <v-chip
                          v-if="items.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ items.color }}
                        </v-chip>
                        <v-chip
                          v-if="items.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ items.color }}
                        </v-chip>
                      </td>
                      <td v-if="!items.color" class="text-center">-</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            <p></p>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      dataReady: true,
      imageUrlBack: '',
      imageHeadHRM: '',
      shifttem: [],
      year: '',
      month: '',
      day: '',
      dadataReadyy: true,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    await this.shift_import()
    // if (JSON.parse(localStorage.getItem('liff_info'))) {
    //   await this.Home()
    // } else {
    await this.shift_import()
    // }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async shift_import () {
      // const today = new Date()
      this.dataReady = true
      this.shifttem = []

      this.month = (this.month !== '') ? this.month : this.getMonthTh()
      this.year = (this.year !== '') ? this.year : moment().format('YYYY')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpCodeShiftMonth?empCode=' +
            JSON.parse(localStorage.getItem('liff_info')).empCode +
            '&shiftMonth=' +
             this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.shifttem = response.data

          this.shifttem.forEach((shifttem) => {
            // console.log(shifttem)
            if (shifttem.color) {
              var timeAssignArray = shifttem.time_as.split(':')
              // console.log(timeAssignArray)
              shifttem.time_as = timeAssignArray[0] + ':' + timeAssignArray[1]
            } else {
              shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
              shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
              shifttem.detail = 'ไม่พบข้อมูล'
              shifttem.colorin = '-'
              shifttem.colorout = '-'
            }
          })

          this.shifttem = this.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          // console.log('x', this.shifttem)
          this.dataReady = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
        })
    },
    GoHomeEvent () {
      this.$router.push('/Liff/HomeEvent')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/AssessmentHistory.vue